import { useCallback } from "react";
import { useToast } from "../toast/toast";

export function BeforeUpload() {
  const { toast } = useToast();

  return useCallback(
    (file) => {
      const isImage = file.type === "image/jpeg" || file.type === "image/png";
      const isSmall = file.size / 1024 / 1024 < 2;
      if (!isImage) toast("JPG эсвэл PNG зураг сонгоно уу", "error");
      if (!isSmall) toast("Зураг 2MB-с бага байх ёстой", "error");
      return isImage && isSmall;
    },
    [toast]
  );
}
